import styled from 'styled-components'
import { VStack } from '../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const FallbackUIWrap = styled(VStack)`
  padding: 20px;
`
